module.exports = __webpack_public_path__ + "static/media/soviet_cossack.7db218aa.png";